import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import {modifyPageLayoutComponents} from '../PageLayout';

import FilterItemsHeader from './FilterItemsHeader';
import template from './FilterItems.rt'
import templateContentHeader from './FilterItemsContentHeader.rt';
import * as FA from './FiltersActions';
import {filterGroupByID} from './FiltersReducer';

import * as Misc from './../../misc';
import {isImageFile, bkgImage} from './../../utilities/helpers';
import {loadingDialog_show, errorBox_Show, messageBox_Show} from './../../actions/A_Popups';
import {AccessRights} from "../../schemas/accessRightsModel";

import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  const {filters} = state;
  const filterGroup = filterGroupByID(filters, +ownProps.location.query.filterGroupID);
  let items = filters.filterGroupItems && filters.filterGroupItems.toJS(),
      additionalImagesPopupSelectedId = filters.additionalImagesPopupSelectedId,
      filterGroups = filters.groupsWithValues.toJS();

  if (filters.filterItemSearchText) {
    const findByProperties = ["displayText", "value"];
    items = items.filter(item => {
      return findByProperties.some(property => {
        return item[property] && item[property].toLowerCase().includes(filters.filterItemSearchText.toLowerCase())
      })
    })
  }

  return {
    filterGroup,
    groupName: filterGroup ? filterGroup.get('name') : '',
    items,
    filterGroupItemsUpdatedSuccessful: filters.filterGroupItemsUpdatedSuccessful,
    expandedFilterGroupItem: filters.expandedFilterGroupItem ? filters.expandedFilterGroupItem.toJS() : null,
    expandedID: filters.expandedFilterGroupItem ? filters.expandedFilterGroupItem.get('id') : 0,
    addingNewGroupItem: filters.addingNewGroupItem,
    additionalImagesPopupVisible: filters.additionalImagesPopupVisible,
    additionalImagesPopupSelectedId,
    additionalImagesPopupSelectedItem: _.find(_ => _.id == additionalImagesPopupSelectedId),
    additionalImageData: filters.additionalImageData,
    filterGroups,
    additionalImagesToDelete: filters.additionalImagesToDelete,
    AR: AccessRights.get(state)
  }
};

const mapDispatchToProps = dispatch => ({
  showLoadingDialog: (show, title, text) => dispatch(loadingDialog_show(show, title, text)),
  showErrorBox: (title, text) => dispatch(messageBox_Show(true, 'error', title, text)),
  getFilterGroupItems: (filterGroupID, parentID) => dispatch(FA.getFilterGroupItems(filterGroupID, parentID)),
  getAllFilterGroupsAndValues: () => dispatch(FA.getAllFilterGroupsAndValues()),
  enableFilterGroupItem: (filterGroupItemID, enable) => dispatch(FA.enableFilterGroupItem(filterGroupItemID, enable)),
  updateFilterGroupItemsOrder: (idx, dx) => dispatch(FA.updateFilterGroupItemsOrder(idx, dx)),
  expandFilterGroupItem: (id) => dispatch(FA.expandFilterGroupItem(id)),
  updateExpandedFilterGroupItemProp: (propName, value) => dispatch(FA.updateExpandedFilterGroupItemProp(propName, value)),
  cancelFilterGroupItemEdit: id => dispatch(FA.cancelFilterGroupItemEdit(id)),
  setActiveFilterGroupItemIcon: file => dispatch(FA.setActiveFilterGroupItemIcon(file)),
  messageBox_Show: (show, type, title, message, buttons) => dispatch(messageBox_Show(show, type, title, message, buttons)),
  errorBox_Show: config => dispatch(errorBox_Show(config)),
  tryAddNewFilterGroupItem: (filterGroupID) => dispatch(FA.tryAddNewFilterGroupItem(filterGroupID)),
  saveFilterGroupItem: item => dispatch(FA.saveFilterGroupItem(item)),
  deleteFilterGroupItem: id => dispatch(FA.deleteFilterGroupItem(id)),
  toggleLock: id => dispatch(FA.toggleFilterLock(id)),
  showAdditionalImages: (show, id) => dispatch(FA.showAdditionalImagesPopup(show, id)),
  addAdditionalImage: (base64ImageUrl) => dispatch(FA.addAdditionalImage(base64ImageUrl)),
  setAdditionalImageFilters: (image, filters) => dispatch(FA.setAdditionalImageFilters(image, filters)),
  saveAdditionalImages: (additionalImageData, toDeleteImages) => FA.saveAdditionalImages(additionalImageData, toDeleteImages),
  deleteAdditionalImage: (image) => dispatch(FA.deleteAdditionalImage(image)),
  setFilterItemSearchText: (filterItemSearchText) => dispatch(FA.setFilterItemSearchText(filterItemSearchText))
});

class FilterItems extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      totalPages: 0,
      itemsToShow: 20,
      renderItems: [],
      selectedFilterCategory: null,
      selectedFilters: [],
      selectedImage: null
    };
  }

  componentDidMount() {
    if (!this.loadItems())
      return;

  }

  componentWillUnmount() {
    this.props.setFilterItemSearchText("");
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filterGroupItemsUpdatedSuccessful) {
      if (!this.loadItems())
        return;
    }
    if (nextProps.items && nextProps.items.length) {
      this.setState({
        totalPages: Math.ceil(nextProps.items.length / this.state.itemsToShow),
        renderItems: nextProps.items.slice(this.state.page*this.state.itemsToShow, this.state.page*this.state.itemsToShow + this.state.itemsToShow)
      });
    }
  }

  loadItems = () => {
    const {filterGroupID} = this.props.location.query;

    if (!filterGroupID || !this.props.filterGroup) {
      hashHistory.push('/filters');
      return false;
    }


    this.props.getFilterGroupItems(filterGroupID);
    this.props.getAllFilterGroupsAndValues();
    return true;
  };

  selectIcon = (e) => {
    Misc.ignoreDefault(e);
    ReactDOM.findDOMNode(this.refs.fileLoader).click();
  }

  handleUploadFieldChange = (e) => {
    let files = null;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    if (!files || !files.length) {
      console.log("No Files selected");
      return;
    }

    const file = files[0];

    if (file.size > 6 * 1024 * 1024) {
      this.props.errorBox_Show({
        title: 'Error',
        text: 'File too large.',
        rightButtonText: 'OK',
        isRightButtonVisible: true
      });
      return;
    }

    if (!isImageFile(file.name)) {
      this.props.errorBox_Show({
        title: 'Error',
        text: 'File is not an image.',
        rightButtonText: 'OK',
        isRightButtonVisible: true
      });
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      ReactDOM.findDOMNode(this.refs.iconHolder).src = reader.result;
    };
    reader.readAsDataURL(file);

    this.props.setActiveFilterGroupItemIcon(file);
  }

  saveGroupItem = () => {
    this.props.saveFilterGroupItem(this.props.expandedFilterGroupItem);
  }

  toggleLock = id => {
    this.props.toggleLock(id).then(() => this.forceUpdate);
  }

  confirmDeleteGroupItem = id => {
    this.props.messageBox_Show(true, 'error', 'Delete', 'Are you sure you want to delete the filter value?',
      [{
        text: 'Yes',
        onClick: () => {
          this.props.deleteFilterGroupItem(id);
          this.props.messageBox_Show();
        }
      }, {
        text: 'Cancel',
        onClick: () => this.props.messageBox_Show()
      }]);
  }

  handlePageClick = (page) => {
    page--; // we need to count from 0, not from 1
    this.setState({
      page,
      renderItems: this.props.items.slice(page*this.state.itemsToShow, page*this.state.itemsToShow + this.state.itemsToShow)
    })
  };

  isFilterSelected = (filter) => {
    return this.state.selectedFilters.indexOf(filter.id) >= 0;
  }
  handleToggleFilter = (filter) => {
    let selectedFilters = [...this.state.selectedFilters]
      , index = selectedFilters.indexOf(filter.id);
    if(index >= 0) {
      selectedFilters.splice(index, 1);
    } else {
      selectedFilters.push(filter.id);
    }
    this.setState({selectedFilters}, () => this.props.setAdditionalImageFilters(this.state.selectedImage, this.state.selectedFilters));
  }

  onAdditionalImageDrop = (file) => {
    this.props.showLoadingDialog(true, "Loading Image...", "Scanning/Loading image, this should only take a moment...")
      .then(() => {
        this.props.showLoadingDialog(false);
        var img = new Image();
        img.onload = () => {
          var height = img.height;
          var width = img.width;
          var warnings = [], errors = [];
          if(height - width !== 0) {
            warnings.push('Image height and width are not equal.  Stone images work best if they are square.');
          }
          if(height > 3840 || width > 3840) {
            warnings.push('Image dimensions are exceeding 3840 pixels in either height or width');
          }
          if(file[0].size > 262144) {
            warnings.push('Image size is exceeding 256kb in size.');
          }
          else if(file[0].size > 4194304) {
            errors.push('Image size is exceeding 4MB in size.');
          }
          if(errors.length > 0) {
            this.props.showErrorBox('Unable to use Image', errors.join('<br />'));
          } else {
            var f = new FileReader();
            f.onload = (e) => {
              this.props.addAdditionalImage(e.target.result);
              //this.setState({thumbnailImageUrl: e.target.result, thumbnailImage: file[0]})
            };
            f.readAsDataURL(file[0]);
          }
        }
        if(file && file.length >= 1 && file[0].preview) {
          img.src = file[0].preview;
        } else {
          this.props.showErrorBox("Unable to use Image", "Unrecognized image format, please use a JPEG or PNG image.");
        }
      });
  }

  selectImage = (image) => {
    this.setState({
      selectedImage: image,
      selectedFilters: image.filterValueIds
    });
  }

  getAdditionalImageStyle = (image) => {
    return {
      'backgroundImage': `url('${image.imageUrl}')`
    };
  }

  saveAdditionalImages = () => {
    this.props.showLoadingDialog(true, "Saving...", "Saving Additional Filter Image Data...");
    this.props.saveAdditionalImages(this.props.additionalImageData, this.props.additionalImagesToDelete)
    .then(response => {
      this.props.showLoadingDialog(false);
      if(response.success) {
        this.props.showAdditionalImages(false);
      } else {
        this.props.showErrorBox('Error saving Additional Images', response.message);
      }
    })
  }

  showAdditionalImagesPopup = (item) => {
    this.props.showAdditionalImages(true, item.id);
    this.setState({selectedImage: null, selectedFilterCategory: null, selectedFilters: []});
  }

  deleteImage = (item => {
    this.props.deleteAdditionalImage(item);
    this.setState({selectedImage: null, selectedFilterCategory: null, selectedFilters: []});
  })

  render() {
    return template.apply(this);
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export const FilterItemsLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(FilterItemsHeader),
  contentHeader: connector(templateContentHeader),
  content: connector(FilterItems),
  pageFooter: null
});

